/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Card, Text } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { useGetAtlassianApplicationConfigurationQuery } from '../../queries';
import { OrganizationJiraAppEditModal } from './OrganizationJiraAppEditModal';

interface OrganizationJiraAppConfigurationProps {
  isPendingUpdate: boolean;
  onChangeIsFormOpen?: (isFormOpen: boolean) => void;
  onUpdatedAppConfiguration: () => void;
}

export function OrganizationJiraAppConfiguration({
  isPendingUpdate,
  onChangeIsFormOpen,
  onUpdatedAppConfiguration,
}: Readonly<OrganizationJiraAppConfigurationProps>) {
  const { data: atlassianApplicationConfiguration } =
    useGetAtlassianApplicationConfigurationQuery();

  return (
    atlassianApplicationConfiguration && (
      <Card>
        <Card.Header
          hasDivider
          rightContent={
            <OrganizationJiraAppEditModal
              atlassianApplicationConfiguration={atlassianApplicationConfiguration}
              isPendingUpdate={isPendingUpdate}
              onChangeIsFormOpen={onChangeIsFormOpen}
              onUpdatedAppConfiguration={onUpdatedAppConfiguration}
            />
          }
          title={<FormattedMessage id="organization.jira.binding.app_configuration.title" />}
        />
        <Card.Body>
          <div className="sw-flex sw-gap-9">
            <div className="sw-flex sw-flex-col sw-gap-3">
              <Text isHighlighted>
                <FormattedMessage id="organization.jira.binding.app_configuration.client_id.label" />
              </Text>
              <Text isHighlighted>
                <FormattedMessage id="organization.jira.binding.app_configuration.client_secret.label" />
              </Text>
            </div>
            <div className="sw-flex sw-flex-col sw-gap-3">
              <Text>{atlassianApplicationConfiguration.clientId}</Text>
              <Text isSubtle>
                <FormattedMessage id="hidden_for_security" />
              </Text>
            </div>
          </div>
        </Card.Body>
      </Card>
    )
  );
}
